import { ReactElement } from "react";

export type HamburgerLoginButtonProps = {
  initialLogin: () => void;
};

export function HamburgerLoginButton({
  initialLogin,
}: HamburgerLoginButtonProps): ReactElement {
  return (
    <>
      <button
        type="button"
        title="Login"
        className="text-black text-xl font-bold leading-6 font-primary"
        onClick={initialLogin}
      >
        Login
      </button>
      <span className="text-black text-xl leading-6">&nbsp;|&nbsp;</span>
      <button
        type="button"
        title="Login"
        className="text-black text-xl font-bold leading-6 font-primary"
        onClick={initialLogin}
      >
        Register
      </button>
    </>
  );
}
